import { VALIDATION_MESSAGES } from "utils/constants";
import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  otp: Yup.string()
    .min(6, VALIDATION_MESSAGES.PROFILE.OTP.INVALID)
    .max(6, VALIDATION_MESSAGES.PROFILE.OTP.INVALID)
    .required(VALIDATION_MESSAGES.PROFILE.OTP.REQUIRED),
});
